import {CouponInfoSheet} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {COLORS} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useRef} from 'react';
import {CoinsWalletContent} from '../../../../features/Coins/CoinsWallet/CoinsWalletContent/CoinsWalletContent';
import {CouponWalletContent} from '../../../../features/Coupons/CouponWallet/CouponWalletContent';
import {WalletPauseState} from '../../WalletPauseState';
import {WALLET_HEADER_HEIGHT} from '../WalletHeader/WalletTabs';
import {WalletContentViewProps} from './WalletContentView';

export const WalletBody: React.FC<
  Pick<
    WalletContentViewProps,
    'activeTab' | 'tabs' | 'setSelectedProduct' | 'ContentPopperLayoutComponent'
  > & {
    handleInfoIconClick: (couponInfo?: CouponInfoSheet) => void;
    headerHeight: number | undefined;
  }
> = ({
  tabs,
  activeTab,
  setSelectedProduct,
  handleInfoIconClick,
  headerHeight,
}) => {
  const wasWalletPauseStateDisplayed = useRef(false);

  const onWalletPauseStateClose = () => {
    wasWalletPauseStateDisplayed.current = true;
  };

  const hasError = tabs.some(
    tab =>
      (tab.type?.$case === 'coinsError' && activeTab === 'coins') ||
      (tab.type?.$case === 'couponsError' && activeTab === 'coupons'),
  );

  const topMovement = headerHeight ? headerHeight + WALLET_HEADER_HEIGHT : 0;

  if (hasError) {
    return null;
  }

  return tabs.map(tab => {
    if (tab.type?.$case === 'coins' && activeTab === 'coins') {
      return (
        <>
          <CoinsWrapper $top={topMovement}>
            <SlideIn>
              <CoinsWalletContent sections={tab.type.coins.sections} />
            </SlideIn>
          </CoinsWrapper>
          {tab.pausedModal && !wasWalletPauseStateDisplayed.current && (
            <WalletPauseState
              {...tab.pausedModal}
              activeTab="coins"
              onClose={onWalletPauseStateClose}
            />
          )}
        </>
      );
    }

    if (tab.type?.$case === 'coupons' && activeTab === 'coupons') {
      return (
        <>
          <CouponWrapper $top={topMovement}>
            <SlideIn>
              <CouponWalletContent
                sections={tab.type.coupons.sections}
                setSelectedProduct={setSelectedProduct}
                paused={!!tab.pausedModal}
                handleInfoIconClick={handleInfoIconClick}
              />
            </SlideIn>
          </CouponWrapper>
          {tab.pausedModal && !wasWalletPauseStateDisplayed.current && (
            <WalletPauseState
              {...tab.pausedModal}
              activeTab="coupons"
              onClose={onWalletPauseStateClose}
            />
          )}
        </>
      );
    }

    return null;
  });
};

const SlideIn = styled.div`
  @keyframes slideIn {
    from {
      transform: translateY(80%);
    }
    to {
      transform: translateY(0);
    }
  }

  animation: slideIn 0.15s ease-out;
  animation-fill-mode: forwards;
`;

const CouponWrapper = styled.div<{$top: number}>`
  border-radius: 16px 16px 0px 0px;
  background-color: ${COLORS.White};
  padding: 32px 16px 48px 16px;
  position: absolute;
  inset: 0;
  z-index: 10;
  transition: transform 0.3s;

  // this is to prevent an animation from the top to the actual position of the bottom sheet
  transform: ${props => (props.$top ? `translateY(${props.$top}px)` : 'unset')};

  height: fit-content;
  min-height: ${props => `calc(100% - ${props.$top}px)`};
`;

const CoinsWrapper = styled(CouponWrapper)`
  max-height: max-content;
`;
